<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script lang="ts" setup>
import { computed, useAttrs } from "vue";
import { CheckIcon } from '@heroicons/vue/24/solid'
import { twMerge } from "tailwind-merge";

const props = defineProps<{
  modelValue?: any[] | Set<any> | boolean;
  value?: unknown;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value?: any[] | Set<any> | boolean): void;
}>();

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value?: any[] | Set<any> | boolean) {
    emit("update:modelValue", value);
  },
});

const { class: wrapperClass, ...attrs } = useAttrs();
</script>

<template>
  <label
    class="checkbox-input"
    :class="twMerge('relative w-8 h-8 inline-block', (wrapperClass as string | string[] | undefined))"
  >
    <input
      v-bind="attrs"
      :value="value"
      v-model="model"
      type="checkbox"
      class="appearance-none transition-color duration-300 w-full h-full rounded-lg border border-[hsla(207,35%,94%,1)] bg-white checked:bg-primary disabled:bg-[hsla(207,35%,94%,1)]"
    />
    <CheckIcon
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4 fill-white"
    />
  </label>
</template>

<style scoped>
  .checkbox-input input + svg {
    @apply hidden;
  }
  .checkbox-input input:checked + svg {
    @apply block;
  }
</style>
